<template>
  <v-app id="app">
    <div id="snackbar" class="cxlt-toastr-container toast-top-right"></div>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { commonApi } from './api/commonApi';
import { getterTypes } from './store/getter-types';
import { actionTypes } from './store/action-types';
import { mutationTypes } from './store/mutation-types';
import tool from '@/common/js/tool';
import { isLogin, logout } from './router/accountUnit';
import i18n from '@/translations';

export default {
  name: 'App',
  data() {
    return {
      currencies: [],
      maxCount: 5,
      getCurrenciesActionCount: 0,
      sobotChartFlag: false
    };
  },
  computed: {
    ...mapGetters([
      getterTypes.Getter_Lang,
      getterTypes.Getter_Langs_List,
      getterTypes.Getter_Current_Currency,
      getterTypes.Getter_ExpireTime,
      getterTypes.Getter_Token
    ])
  },
  watch: {
    $route() {
      let url = window.location.href.toLowerCase();
      const currentLang = this.Getter_Lang;
      if (url.indexOf('exchange') === -1) {
        if (currentLang.code === 'zh_CN' || currentLang.code === 'zh_TW') {
          if (!this.sobotChartFlag) {
            this.initSobotLiveChat();
            this.sobotChartFlag = true;
          }
        } else {
          // init u desk
          this.initUDeskLiveChat();
        }
      } else {
        this.sobotChartFlag = false;
      }
      // to holds where they are going
      // from holds where they are coming from
    }
  },
  created() {
    this.connectSocket();
    this._getCurrencies();
    this.setDefaultLang();
    this.GET_MARKETLIST_ACTION();
    // window.addEventListener('storage', this.onStorageEvent);
    if (isLogin()) {
      this.GET_USERINFO_ACTION().then(res => {
        let data = res.data;
        if (data) {
          // 防止刷新页面后 点击退出登录后 store中的 username 未改变 导致的用户名一直显示的bug
          this.SET_USERNAME(data.userName);
        }
      });
    } else {
      logout();
    }

    if (this.Getter_Token) {
      this.getNotificationCount();
    }
  },
  methods: {
    ...mapMutations([
      mutationTypes.SET_LANG,
      mutationTypes.SET_CURRENCY,
      mutationTypes.SET_INFOMATIONNAV,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_SOCKET_STATE
    ]),
    ...mapActions([
      actionTypes.GET_LANGS_ACTION,
      actionTypes.GET_CURRENCIES_ACTION,
      actionTypes.GET_COIN_LIST_ACTION,
      actionTypes.GET_MARKETLIST_ACTION,
      actionTypes.GET_TRADING_PAIRS_LIST_ACTION,
      actionTypes.CLEAR_USERINFO_ACTION,
      actionTypes.GET_USERINFO_ACTION,
      'getUnreadMessageCount_action'
    ]),
    // onStorageEvent(e) {
    //   if (e.key === 'token') {
    //     location.reload();
    //   }
    // },
    async setDefaultLang() {
      // const browserLang = tool.getBrowserLang();
      // If the current language is already set in local storage, then set it to vuex store
      if (this.Getter_Lang && this.Getter_Lang.code) {
        this.SET_LANG(this.Getter_Lang);
        this.GET_LANGS_ACTION();
      } else {
        await this.GET_LANGS_ACTION();
        let langList = this.Getter_Langs_List;
        for (let item of langList) {
          if (item.code === 'en_US') {
            this.SET_LANG(item);
            return;
          }
        }
      }
      i18n.locale = this.Getter_Lang.code;
    },
    async _getCurrencies() {
      try {
        this.getCurrenciesActionCount++;
        // 获取法定货币列表
        let res = await this.GET_CURRENCIES_ACTION();
        this.currencies = res.data;
        this.setDefaultCurrency();
      } catch (e) {
        if (this.getCurrenciesActionCount <= this.maxCount) {
          this._getCurrencies();
        }
      }
    },
    setDefaultCurrency() {
      let currency = this.Getter_Current_Currency;
      // 设置默认货币
      if (JSON.stringify(currency) === '{}') {
        if (this.currencies.length > 0) {
          currency = this.currencies[0];
          this.SET_CURRENCY(currency);
        }
      }
    },
    connectSocket() {
      this.$socket.onConnect = connected => {
        if (connected) {
          this.SET_SOCKET_STATE(true);
          if (this.Getter_Token) {
            let token = this.Getter_Token.replace('Bearer ', '');
            this.$socket.emit('authorize', token).then(response => {});
          }
        } else {
          this.SET_SOCKET_STATE(false);
        }
      };
    },
    getNotificationCount() {
      setInterval(() => {
        this.getUnreadMessageCount_action();
      }, 60000);
    },
    initSobotLiveChat() {
      /*(function(w, d, e, x) {
        w[e] = function() {
          w.cbk = w.cbk || [];
          w.cbk.push(arguments);
        };
        x = d.createElement('script');
        x.async = true;
        x.id = 'zhichiScript';
        x.src = 'https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=e9a8f95f53d04ad9ada82f01608722f4&channelid=2';
        d.body.appendChild(x);
      })(window, document, 'zc');*/
    },
    initUDeskLiveChat() {
      /*(function(a, h, c, b, f, g) {
        a['UdeskApiObject'] = f;
        a[f] =
          a[f] ||
          function() {
            (a[f].d = a[f].d || []).push(arguments);
          };
        g = h.createElement(c);
        g.async = 1;
        g.charset = 'utf-8';
        g.src = b;
        c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c);
      })(window, document, 'script', 'https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js', 'ud');
      ud({
        code: '1197k1dg',
        link: 'https://grxtrade.s2.udesk.cn/im_client/?web_plugin_id=21004&language=en-us',
        onlineText: 'Online',
        offlineText: 'Offline'
      });*/
    }
  }
};
</script>

<style lang="stylus">
@import './common/styles';
</style>
